var a, s,
SC = {
  
  elements: {
    header: document.querySelector('.header'),
    headerAnnouncement: document.querySelector('.header__announcement'),
    siteLoader: document.querySelector('[site-loader]'),
    searchTrigger: document.querySelector('[header-search-trigger]'),
    searchInput: document.querySelector('[header-search-form-input]'),
    mobileSearchInput: document.querySelector('[header-search-form-mobile-input]'),
    mobMenuTrigger: document.querySelector('[header-mob-menu-trigger]'),
    cartTriggers: document.querySelectorAll('[header-cart-trigger]'),
    cartDrawer: document.querySelector('[cart-drawer]'),
    cartDrawerCloseBtn: document.querySelector('[cart-drawer-close-btn]'),
    backdrop: document.querySelector('[backdrop]'),
    accountForgotPassTrigger: document.querySelector('[account-forgot-password-trigger]'),
  },

  settings: {
    swup: null,
    debounceTimer: null,
    scrolled: false,
  },

  init: function() {
    a = this.elements;
    s = this.settings;
    this.swup();
    this.onevh();
    this.siteLoader();
    this.header();
    this.mobMenu();
    // this.search();
    // this.cartDrawer();
    this.backdrop();
    this.redirects();
    this.scrollingBanner();
    this.cart();

    // this.heroBanner();
    // this.gallery();
    this.blogListingPagination();
    this.productSingleSlider();
    this.productSingleVariants();
    this.productSingleAccordions();
    this.productSingleCountdown();
    // this.collectionFiltering();
    // this.collectionFilteringMobile();
   this.collectionInfiniteLoading();
    // this.newsletter();
    // this.account();
    this.policies();
    this.heroSliders();
    // this.heroMediaSections();
    //this.shopifyFormSubmissions();
  },

  swup: () => {
    a.swup = new Swup({
      plugins: [
        new SwupFormsPlugin(),
        new SwupScrollPlugin({
          doScrollingRightAway: false,
          animateScroll: false,
        }),
        new SwupBodyClassPlugin(),
        new SwupScriptsPlugin({
          head: false,
          body: true,
        })
      ],
      animateHistoryBrowsing: true,
      containers: [
        '.site-content',
      ],
    });

    a.swup.on('contentReplaced', () => {
      // SC.heroBanner();
      // SC.gallery();
      SC.blogListingPagination();
      SC.productSingleSlider();
      SC.productSingleVariants();
      SC.productSingleAccordions();
      SC.productSingleCountdown();
      // SC.collectionFiltering();
      // SC.collectionFilteringMobile();
     SC.collectionInfiniteLoading();
      // SC.newsletter();
      // SC.account();
      SC.policies();
      SC.heroSliders();
      // SC.heroMediaSections();
      // SC.shopifyFormSubmissions();
    });
  },

  header: () => {    

    let lastKnownScrollPosition = 0;
    let ticking = false;
    
    function doSomething(scrollPos) {
      // Do something with the scroll position
      if (scrollPos > 150) {
        a.header.classList.add('header--scrolled');

        s.scrolled = true;
      } else {
        a.header.classList.remove('header--scrolled');

        s.scrolled = false;
      }
    }
    
    document.addEventListener("scroll", (event) => {
      lastKnownScrollPosition = window.scrollY;
    
      if (!ticking) {
        window.requestAnimationFrame(() => {
          doSomething(lastKnownScrollPosition);
          ticking = false;
        });
    
        ticking = true;
      }
    });

  },

  policies: () => {
    const policyBody = document.querySelector('.shopify-policy__container');

    if (policyBody) {
      policyBody.classList.add('content');
    }
  },

  redirects: () => {
    if (window.location.pathname == '/cart') {
		window.location.href = '/?cart=true'; 
	}
  },

  siteLoader: () => {
    const mask = a.siteLoader.querySelector('.site-loader__mask');

    gsap
      .to(mask, { clipPath:"polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", ease: "expo.inOut", duration: 3 });
    
    setTimeout(() => {
      a.siteLoader.classList.add('site-loader--done');
    }, 2500);
  },
  
  onevh: () => {
    const set1vh = () => {
      const vh = document.documentElement.clientHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    set1vh();

    const setHeaderHeight = () => {
      const h = document.querySelector('.header').offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    };

    setHeaderHeight();

    const setHeaderAnnounementHeight = () => {
      if (a.headerAnnouncement) {
        document.documentElement.style.setProperty('--header-announcement-height', `${a.headerAnnouncement.offsetHeight}px`);
      }
    };

    setHeaderAnnounementHeight();

    window.addEventListener('resize', set1vh);
    window.addEventListener('resize', setHeaderHeight);
    window.addEventListener('resize', setHeaderAnnounementHeight);
  },

  mobMenu: () => {
    a.mobMenuTrigger.addEventListener('click', () => {
      const expanded = a.mobMenuTrigger.getAttribute('aria-expanded') === 'true';

      a.mobMenuTrigger.setAttribute('aria-expanded', !expanded);
      const mobMenuTarget = document.querySelector(`#${a.mobMenuTrigger.getAttribute('aria-controls')}`);
      mobMenuTarget.setAttribute('aria-expanded', !expanded);

      const items = document.querySelectorAll('li');

      if (!expanded) {
        gsap.set(items, { opacity: 0, y: '1rem' });
        document.documentElement.classList.add('mob-menu-active');
        document.documentElement.classList.add('overflow-hidden');
        if (!s.scrolled && a.headerAnnouncement) {
          gsap.to(a.headerAnnouncement, { duration: 0.25, height: 0 });
        }

        gsap.to(items, { opacity: 1, y: 0, stagger: 0.1 });
      } else {
        document.documentElement.classList.remove('mob-menu-active');
        document.documentElement.classList.remove('overflow-hidden');

        if (!s.scrolled && a.headerAnnouncement) {
          gsap.to(a.headerAnnouncement, { duration: 0.25, height: 'auto' });
        }
      }
    });

    const headerLinks = document.querySelectorAll('.header__mob-menu a');

    if (headerLinks) {
      for (let headerLink of headerLinks) {
        headerLink.addEventListener('click', () => {
          SC.closeMobileMenu();
        });
      }
    }
  },

  closeMobileMenu: () => {
    a.mobMenuTrigger.setAttribute('aria-expanded', false);
    const mobMenuTarget = document.querySelector(`#${a.mobMenuTrigger.getAttribute('aria-controls')}`);
    mobMenuTarget.setAttribute('aria-expanded', false);
    document.documentElement.classList.remove('mob-menu-active');
    document.documentElement.classList.remove('overflow-hidden');
  },

  debounce: (callback, time) => {
    window.clearTimeout(a.debounceTimer);
    a.debounceTimer = window.setTimeout(callback, time);
  },

  search: () => {
    a.searchTrigger.addEventListener('click', () => {
      const expanded = a.searchTrigger.getAttribute('aria-expanded') === 'true';

      a.header.classList.toggle('search-open');

      a.searchTrigger.setAttribute('aria-expanded', !expanded);
      
      const searchTarget = document.querySelector(`#${a.searchTrigger.getAttribute('aria-controls')}`);
      searchTarget.setAttribute('aria-expanded', !expanded);

      if (!expanded) {
        // https://stackoverflow.com/questions/12204571/mobile-safari-javascript-focus-method-on-inputfield-only-works-with-click
        // create invisible dummy input to receive the focus first
        const fakeInput = document.createElement('input')
        fakeInput.setAttribute('type', 'text')
        fakeInput.style.position = 'absolute'
        fakeInput.style.opacity = 0
        fakeInput.style.height = 0
        fakeInput.style.fontSize = '16px' // disable auto zoom
      
        // you may need to append to another element depending on the browser's auto 
        // zoom/scroll behavior
        document.body.prepend(fakeInput)
      
        // focus so that subsequent async focus will work
        fakeInput.focus()
      
        setTimeout(() => {
          // now we can focus on the target input
          a.searchInput.focus()
          // cleanup
          fakeInput.remove()
        }, 350);
        
        document.documentElement.classList.remove('desktop-menu-active');
        document.documentElement.classList.remove('mob-menu-active');
      }
    });

    a.searchInput.addEventListener('keyup', e => {
      if (e.target.value.length > 2) {
        let formData = new FormData(e.target.closest('form'));
        let search = new URLSearchParams(formData);
        let queryString = search.toString();

        SC.debounce(() => {
          a.swup.loadPage({
            url: `/search?${queryString}`
          });
        }, 500);
      }
    });

    a.searchInput.closest('form').addEventListener('submit', e => {
      SC.closeSearch();
    });

    a.mobileSearchInput.closest('form').addEventListener('submit', e => {
      SC.closeMobileMenu();
    });
  },

  closeSearch: () => {
    const searchTarget = document.querySelector(`#${a.searchTrigger.getAttribute('aria-controls')}`);
    searchTarget.setAttribute('aria-expanded', false);
    a.searchTrigger.setAttribute('aria-expanded', false);
  },

  cartDrawer: () => {
    for (const cartTrigger of a.cartTriggers) {
      cartTrigger.addEventListener('click', () => {
        SC.openCart(cartTrigger);
      });
    }

    a.cartDrawerCloseBtn.addEventListener('click', () => {
      SC.closeCart();
    });

    // Open cart if ?cart=true
	const url_search_params = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(url_search_params.entries());
	if (params.cart) {
      SC.openCart();
	}
  },

  openCart: (cartTrigger) => {
    a.cartDrawer.setAttribute('aria-expanded', true);
    if (cartTrigger) {
      cartTrigger.setAttribute('aria-expanded', true);
    }
    SC.openBackdrop();
  },

  closeCart: () => {
    for (const cartTrigger of a.cartTriggers) {
      cartTrigger.setAttribute('aria-expanded', false);
    }

    a.cartDrawer.setAttribute('aria-expanded', false);

    SC.closeBackdrop();
  },

  backdrop: () => {
    a.backdrop.addEventListener('click', () => {
      SC.closeBackdrop();
      SC.closeCart();
      SC.closeAccount();
    });
  },

  openBackdrop: () => {
    a.backdrop.classList.add('backdrop--open');
    document.body.classList.add('overflow-hidden');
  },

  closeBackdrop: () => {
    a.backdrop.classList.remove('backdrop--open');
    document.body.classList.remove('overflow-hidden');
  },

  blogListingPagination: () => {
   /*const paginationNext = document.querySelector('[blog-listing-pagination-link]');

	if (paginationNext) {
      paginationNext.addEventListener('click', e => {
        e.preventDefault();
        SC.loadBlogPosts();
        paginationNext.classList.add('button--loading');
      });
	}*/
    const blogItems = document.querySelector('[blog-listing-items]');

    if (blogItems) {
      let infinitePostsLoading = false;

		const st = ScrollTrigger.create({
			trigger: blogItems,
			start: 'bottom bottom+=50px',
			onEnter: (e) => {
				if (!infinitePostsLoading) {
					SC.loadBlogPosts(e, infinitePostsLoading, blogItems)
				}
			},
		});
    }
  },

  loadBlogPosts: (e, infinitePostsLoading, blogItems) => {
	/*const paginationNext = document.querySelector('[blog-listing-pagination-link]');

	if (paginationNext) {
      const productContainer = document.querySelector('[blog-listing-items]');

      fetch(paginationNext.href)
      .then(response => {
        return response.text()
      }).then(data => {
        const parser = new DOMParser()
        data = parser.parseFromString(data, 'text/html')

        const newProducts = data.querySelector('[blog-listing-items]');
        const newPaginationNext = data.querySelector('[blog-listing-pagination-link]');

        if (newPaginationNext) {
          paginationNext.parentNode.innerHTML = newPaginationNext.parentNode.innerHTML;
        } else {
          paginationNext.parentNode.remove();
        }

        productContainer.insertAdjacentHTML('beforeend', newProducts.innerHTML);
        SC.blogListingPagination();
        paginationNext.classList.remove('button--loading');
      });
	}*/
    infinitePostsLoading = true;

	const paginationNext = document.querySelector('[blog-listing-pagination-link]');

	if (paginationNext) {
      blogItems.classList.add('blog-listing__articles--loading');
      fetch(paginationNext.href)
		.then(response => {
			return response.text()
		}).then(function (data) {

			const parser = new DOMParser()
            data = parser.parseFromString(data, 'text/html')
    
            const newPosts = data.querySelector('[blog-listing-items]');
            const newPaginationNext = data.querySelector('[blog-listing-pagination-link]');
    
            if (newPaginationNext) {
              paginationNext.parentNode.innerHTML = newPaginationNext.parentNode.innerHTML;
            } else {
              paginationNext.parentNode.remove();
            }
    
            blogItems.insertAdjacentHTML('beforeend', newPosts.innerHTML);
            blogItems.classList.remove('blog-listing__articles--loading');
			e.refresh();
		})
	}
  },

  heroSliders: () => {
    const productSingleMediaSliders = document.querySelectorAll('.hero-media__item--slider');

    if (productSingleMediaSliders) {
      productSingleMediaSliders.forEach((slider) => {
        const flkty = new Flickity(slider, {
          autoPlay: false,
          pageDots: false,
          prevNextButtons: true,
          cellAlign: 'left',
          contain: true,
          adaptiveHeight: true,
        });
      });
      
    }
  },

  productSingleSlider: () => {
    const productSingleMediaSlider = document.querySelector('[product-single-media-slider]');

    if (productSingleMediaSlider) {
      const flkty = new Flickity(productSingleMediaSlider, {
        autoPlay: false,
        pageDots: true,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        adaptiveHeight: true,
        initialIndex: parseInt(productSingleMediaSlider.dataset.start),
      });
    }
  },

  productSingleVariants: () => {
    const productSubmit = document.querySelector('[product-single-form-submit]');

	if (productSubmit) {
      const productVariantsRawJSON = document.querySelector('[product-single-form-variants]');
      const productVariantsJSON = JSON.parse(productVariantsRawJSON.innerHTML);

      const productPrice = document.querySelector('[product-single-form-price]');
      const productFormId = document.querySelector('[product-single-form-id]');
      const productOptions = document.querySelectorAll('[product-single-form-option]');
      const productQuantity = document.querySelector('[product-single-form-quantity]');
      const productOptionColours = document.querySelectorAll('[product-single-form-option-colour]');
      
      if (productOptions.length > 0) {
        for (const productOption of productOptions) {
          productOption.addEventListener('change', () => {
            SC.productCheckVariants(productFormId, productPrice, productSubmit, productOptions, productVariantsJSON);
          });
        }
      }

      if (productOptionColours.length > 0) {
        for (const productOption of productOptionColours) {
          productOption.addEventListener('click', () => {
            for (const productOptionn of productOptionColours) {
              productOptionn.classList.remove('product-single__form-option-colour-selected');
            }
            productOption.classList.add('product-single__form-option-colour-selected');

            const index = productOption.parentNode.dataset.index;
            for (const productOptionn of productOptions) {
              if (productOptionn.dataset.index === index) {
                productOptionn.value = productOption.dataset.value;
                SC.productCheckVariants(productFormId, productPrice, productSubmit, productOptions, productVariantsJSON);
                break;
              }
            }
          });
        }
      }

      const productForm = productSubmit.closest('form');
      
      productForm.addEventListener('submit', e => {
        e.preventDefault();
        const properties = productForm.querySelectorAll('[name^=properties]');
        SC.productAddToCart(productFormId.value, parseInt(productQuantity.value), productSubmit, properties);
      });
	}
  },

  productCheckVariants: (productFormId, productPrice, productSubmit, productOptions, productVariantsJSON) => {
    let productOptionsArray = [];
	let productSingleVariant = false;

	productOptions.forEach((productOption) => {
      productOptionsArray.push([
        productOption.dataset.index,
        productOption.value,
      ]);
	});

	let i;
	for (i = 0; i < productVariantsJSON.length; i++) {
      const variant = productVariantsJSON[i];
      let matched = [];

      let k;
      for (k = 0; k < productOptionsArray.length; k++) {
        // if value of selected option == the same option number value
        if (productOptionsArray[k][1] == variant[productOptionsArray[k][0]]) {
          matched.push(1);
        } else {
          break;
        }
      }

      if (matched.length == productOptionsArray.length) {
        productSingleVariant = variant;
      }
	}

	if (productSingleVariant) {
      // Update product image slider
      const productSingleMediaSlider = document.querySelector('[product-single-media-slider]');
      if (productSingleMediaSlider && productSingleVariant.featured_image) {
        const flkty = Flickity.data(productSingleMediaSlider);
        flkty.select(productSingleVariant.featured_image.position - 1);
      }
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?variant=${productSingleVariant.id}`
      );

      const productSingleSoldOutBadge = document.querySelector('[product-single-form-sold-out]');
      
      if (productSingleVariant.available == true) {
        productSubmit.disabled = false;
        productSingleSoldOutBadge.classList.remove('product-single__badges-badge--active');
        if (!productSingleSoldOutBadge.parentNode.classList.contains('product-single__badges--multiple')) {
          productSingleSoldOutBadge.parentNode.classList.remove('product-single__badges--active');
        }
      } else {
        productSubmit.disabled = true;
        productSingleSoldOutBadge.classList.add('product-single__badges-badge--active');
        productSingleSoldOutBadge.parentNode.classList.add('product-single__badges--active');
      }

      const variantPrice = productSingleVariant.price;
      const variantCap = productSingleVariant.compare_at_price;

      if (variantPrice < variantCap) {
        productPrice.innerHTML =
        '<del>$' +
        (variantCap / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        "</del> $" +
        (variantPrice / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        productPrice.innerHTML = "$" + (variantPrice / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      productFormId.value = productSingleVariant.id;
	} else {
      // Variant doesn't exist
      productSubmit.disabled = true;
	}
  },

  productAddToCart: (varaintId, quantity, productSubmit, properties) => {
    productSubmit.classList.add('button--loading');
    productSubmit.disabled = true;

    const cartContents = document.querySelector('[cart-drawer-contents]');
    gsap.to(cartContents, { duration: 0.25, opacity: 0 });

	let formData = {
      items: [
        {
          id: varaintId,
          quantity: quantity,
        },
      ],
      sections: "cart-drawer"
	};

	if (properties) {
      formData.items[0].properties = {};

      properties.forEach(property => {
        const name = property.name.match(/\[(.*?)\]/)[1];
        formData.items[0].properties[name.charAt(0).toUpperCase() + name.slice(1)] = property.value;
      });
	}

	fetch("/cart/add.js", {
    	method: "POST",
    	headers: {
          "Content-Type": "application/json",
    	},
    	body: JSON.stringify(formData),
	})
	.then((response) => {
      return response.json();
	})
	.then(data => {
      if (data.status == 422) {
        // Too many
        productSubmit.classList.remove('button--loading');
        productSubmit.textContent = productSubmit.dataset.cartLimitText;

        setTimeout(() => {
          productSubmit.textContent = productSubmit.dataset.addText;
        }, 4000);

        gsap.to(cartContents, { duration: 0.25, opacity: 1 });
      } else {
        // Added to cart
        SC.openCart();

        productSubmit.classList.remove('button--loading');
        productSubmit.disabled = false;

        const headerCartItems = document.querySelector("[header-cart-item-count]");
        headerCartItems.setAttribute('header-cart-item-count', data.items.length);
        headerCartItems.textContent = data.items.length;
        if (data.items.length > 0) {
          headerCartItems.parentNode.classList.add('header__menu-item-link-icon-cart-count--active');
        } else {
          headerCartItems.parentNode.classList.remove('header__menu-item-link-icon-cart-count--active');
        }
        
        const updatedCart = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        cartContents.innerHTML = updatedCart.querySelector('[cart-drawer-contents]').innerHTML;

        gsap.to(cartContents, { duration: 0.25, opacity: 1 });
  
        SC.cart();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  },

  productSingleAccordions: () => {
    const productSingleAccordions = document.querySelectorAll('[product-single-accordion-btn]');

    if (productSingleAccordions.length) {
      for (let productSingleAccordion of productSingleAccordions) {
        productSingleAccordion.addEventListener('click', () => {
          const expanded = productSingleAccordion.getAttribute('aria-expanded') === 'true';

          productSingleAccordion.setAttribute('aria-expanded', !expanded);
          productSingleAccordion.nextElementSibling.setAttribute('aria-expanded', !expanded);

          if (!expanded) {
            gsap.to(productSingleAccordion.nextElementSibling, { duration: 0.25, height: 'auto', autoAlpha: 1 });
          } else {
            gsap.to(productSingleAccordion.nextElementSibling, { duration: 0.25, height: 0, autoAlpha: 0 });
          }
        });
      }
    }
  },

  cart: () => {
    const cartItems = document.querySelectorAll('[cart-form-item]');

	if (cartItems.length) {
      cartItems.forEach((cartItem, i) => {
        // Links
        const links = cartItem.querySelectorAll('a');

        for (let link of links) {
          link.addEventListener('click', () => {
            SC.closeCart();
          });
        }
        
        const index = i + 1;
        // Remove
        const itemRemove = cartItem.querySelector('[cart-form-item-remove]');

        itemRemove.addEventListener('click', () => {
          const formData = {
            'line': index,
            'quantity': 0,
            sections: "cart-drawer"
          }

          SC.updateCart(formData);
        });
  
        // Quantity
        const quantityField = cartItem.querySelector('[cart-drawer-item-qty-amount]');
        const quantityAddBtn = cartItem.querySelector('[cart-drawer-item-qty-plus]');
        const quantityMinusBtn = cartItem.querySelector('[cart-drawer-item-qty-minus]');

        quantityAddBtn.addEventListener('click', () => {
          const quantity = parseInt(quantityField.textContent) + 1;

          const formData = {
            'line': index,
            'quantity': quantity,
            sections: "cart-drawer"
          }

          SC.updateCart(formData)
        });
          
        quantityMinusBtn.addEventListener('click', () => {
          const quantity = parseInt(quantityField.textContent) - 1;
  
          const formData = {
            'line': index,
            'quantity': quantity,
            sections: "cart-drawer"
          }

          SC.updateCart(formData);
        });
      });
	}
  },

  updateCart: (formData) => {
	a.cartDrawer.classList.add('drawer-loader--loading');
    const cartContents = document.querySelector('[cart-drawer-contents]');

	fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
	})
	.then(response => {
      return response.json()
	})
	.then(data => {
      if (data.status == 422) {
        // Too many
        a.cartDrawer.classList.remove('drawer-loader--loading');
        gsap.to(cartContents, { duration: 0.25, opacity: 1 });
      } else {
        const headerCartItems = document.querySelector("[header-cart-item-count]");
        headerCartItems.setAttribute('header-cart-item-count', data.item_count);
        headerCartItems.textContent = data.item_count;

        if (data.item_count > 0) {
          headerCartItems.parentNode.classList.add('header__menu-item-link-icon-cart-count--active');
        } else {
          headerCartItems.parentNode.classList.remove('header__menu-item-link-icon-cart-count--active');
        }
  
        const updatedCart = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        cartContents.innerHTML = updatedCart.querySelector('[cart-drawer-contents]').innerHTML;
    
        SC.cart();
  
        a.cartDrawer.classList.remove('drawer-loader--loading');
      }
	});
  },

  collectionInfiniteLoading: () => {
    const collectionItems = document.querySelector('[collection-items]');

    if (collectionItems) {
      let infiniteProductsLoading = false;

		const st = ScrollTrigger.create({
			trigger: collectionItems,
			start: 'bottom bottom+=50px',
			onEnter: (e) => {
				if (!infiniteProductsLoading) {
					SC.loadInfiniteProducts(e, infiniteProductsLoading, collectionItems)
				}
			},
		});
    }
  },

  loadInfiniteProducts: (e, infiniteProductsLoading, collectionItems) => {
    infiniteProductsLoading = true

	const paginationNext = document.querySelector('.collection__pagination-btn--next')

	if (paginationNext) {
      collectionItems.classList.add('collection__grid--loading');
      fetch(paginationNext.href)
		.then(response => {
			return response.text()
		}).then(function (data) {

			const parser = new DOMParser()
			data = parser.parseFromString(data, 'text/html')
			
			paginationNext.parentElement.parentElement.remove()

			const newProducts = data.querySelector('[collection-items]')

			collectionItems.insertAdjacentHTML('beforeend', newProducts.innerHTML)

			infiniteProductsLoading = false
            collectionItems.classList.remove('collection__grid--loading');

			e.refresh()

		})
	}
  },

   scrollingBanner: function(){

    const scrollingBanner = document.querySelector('.header__announcement--scrolling')

    if (scrollingBanner) {

      Marquee3k.init({
          selector: 'header__announcement--scrolling'
      })

      window.addEventListener('load', function(){
          Marquee3k.refreshAll()
      })

    }
	
  },

  productSingleCountdown: function() {
    const countdown = document.querySelector('[product-countdown]');

    if (countdown) {
      // Set the date we're counting down to
      var countDownDate = new Date(countdown.dataset.date).getTime();

      var now = new Date().getTime();
      
      // Find the distance between now an the count down date
      var distance = countDownDate - now;

      const atc = document.querySelector('.product-single__form');

      if (countDownDate - now > 0) {        
        atc.classList.add('product-single__form--disabled');
        
        // Update the count down every 1 second
        var x = setInterval(function() {
        
          // Get todays date and time
          var now = new Date(new Date().toLocaleString("en-US", {timeZone: "Australia/Sydney"})).getTime();
        
          // Find the distance between now an the count down date
          var distance = countDownDate - now;
        
          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
          // Display the result in the element with id="demo"
          countdown.innerHTML = '<span>' + days.toString().padStart(2, '0') + "</span>:<span>" + hours.toString().padStart(2, '0') + "</span>:<span>" + minutes.toString().padStart(2, '0') + "</span>:<span>" + seconds.toString().padStart(2, '0') + '</span>';
        
          // If the count down is finished, write some text 
          if (distance < 0) {
            clearInterval(x);
            countdown.parentElement.remove();

            atc.classList.remove('product-single__form--disabled');
          }
        }, 1000);
      } else {
        countdown.parentElement.remove();
      }
    }
  },

};

(function() {
  SC.init();
})();